// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1FpH3","left":"StickyBox_left__42AWr","right":"StickyBox_right__TDMS2"};